/**
 * A global namespace for aria-labelledby.
 */
const ariaLabelledBy = "aria-labelledby";
export default ariaLabelledBy;
